import * as GC from '@mescius/spread-sheets';
import * as _ from 'lodash-es';
import {
  disabledContextMenuItemForCell,
  disabledContextMenuItemForSheetTab,
} from '../constants/spreadContextMenu';

/**
 * コンテキストメニューの表示制御
 */
export function setupContextMenu(spread: GC.Spread.Sheets.Workbook): void {
  const defaultOnOpenMenu = spread.contextMenu.onOpenMenu.bind(
    spread.contextMenu
  );

  spread.contextMenu.onOpenMenu = (
    menuData,
    itemDataForShown,
    hitInfo: { worksheetHitInfo?: GC.Spread.Sheets.IHitTestInformation },
    workbook: GC.Spread.Sheets.Workbook
  ) => {
    const result = defaultOnOpenMenu(
      menuData,
      itemDataForShown,
      hitInfo,
      workbook
    );

    if (hitInfo.worksheetHitInfo) {
      const { row, col, hitTestType } = hitInfo.worksheetHitInfo;

      if (_.isUndefined(row) || _.isUndefined(col)) return result;

      // セルのコンテキストメニューから特定のアイテムを除外する
      if (hitTestType === GC.Spread.Sheets.SheetArea.viewport) {
        for (let i = itemDataForShown.length - 1; i >= 0; i--) {
          if (
            disabledContextMenuItemForCell.has(itemDataForShown[i].name ?? '')
          ) {
            itemDataForShown.splice(i, 1);
          }
        }
      }

      if (itemDataForShown[itemDataForShown.length - 1].type === 'separator') {
        itemDataForShown.splice(itemDataForShown.length - 1, 1);
      }

      return result;
    }

    // シートタブのコンテキストメニューから特定のアイテムを除外する
    for (let i = itemDataForShown.length - 1; i >= 0; i--) {
      if (
        disabledContextMenuItemForSheetTab.has(itemDataForShown[i].name ?? '')
      ) {
        itemDataForShown.splice(i, 1);
      }
    }

    return result;
  };
}
